// Import Swiper.js
// import Swiper from 'swiper';
import { Swiper, Navigation, Autoplay, Pagination, Scrollbar, EffectCoverflow } from 'swiper/swiper.esm';
Swiper.use([Navigation, Autoplay, Pagination, Scrollbar, EffectCoverflow]);
// window.swiper = Swiper;

$(document).ready(function() {
  /* eslint-disable */
  var firstSlide = Math.floor(Math.random() * 5);
  var swiper = new Swiper(".swiper-container", {
    centeredSlides: false,
    cssMode: true,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    initialSlide: firstSlide,
    autoplay: {
      delay: 8500,
      disableOnInteraction: false,
    },
    scrollbar: false,
    pagination: false,
  });



  /* eslint-enable */
});





// WEBPACK FOOTER //
// ./scripts/partials/swiper-init.js